<template>
  <b-modal
    ref="update-cate-modal"
    hide-footer
    title="Cập nhật danh mục"
  >
    <CategoryForm
      :initial-data="formData"
      :list-cate="listCate"
      @submit="handleSubmit"
      @cancel="hideModal"
    />
  </b-modal>
</template>

<script>
import CategoryForm from './CategoryForm.vue';

export default {
  name: 'UpdateCategoryModal',
  components: {
    CategoryForm,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    listCate: {
      type: Array,
      required: true,
    },
  },
  methods: {
    showModal() {
      this.$refs['update-cate-modal'].show();
    },
    hideModal() {
      this.$refs['update-cate-modal'].hide();
    },
    handleSubmit(formData) {
      this.$emit('submit', formData);
    },
  },
};
</script> 
